export enum RoleEnum {
  ADMIN = 0,
  EMPLOYEE = 1,
  TEAMLEAD = 2,
  DEPARTMENT_ADMIN = 3,
  HR = 4
}

export enum RoleNameEnum {
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
  TEAMLEAD = 'TEAMLEAD',
  DEPARTMENT_ADMIN = 'DEPARTMENT_ADMIN',
  HR = 'HR'
}
